import cacheService from '../../../services/cacheService';
import { getPathway } from '../api/getPathway';
import { Pathway } from '../models/pathway';

const delay = (ms: number): Promise<void> => new Promise(resolve => setTimeout(resolve, ms));

export const invalidatePathwayCache = (pathwayId: string): void => {
  cacheService.remove(`/v1/workflows/${pathwayId}`);
};

export function pollForPathwayName(
  pathwayId: string,
  expectedName: string,
  maxAttempts = 5,
  delayMs = 1000
): Promise<Pathway> {
  function attempt(remaining: number): Promise<Pathway> {
    invalidatePathwayCache(pathwayId);

    return getPathway(pathwayId).then((pathway: Pathway) => {
      if (pathway.name === expectedName) {
        return pathway;
      }

      if (remaining <= 1) {
        throw new Error(`Pathway name was not updated after ${maxAttempts} attempts for pathway ${pathwayId}`);
      }

      return delay(delayMs).then(() => attempt(remaining - 1));
    });
  }

  return attempt(maxAttempts);
}
